module.exports = __webpack_public_path__ + "static/img/mice-and-men.b9f9725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/mice-and-men.jpg
// module id = Kc9V
// module chunks = 1